import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { Button } from '@/shared/components/atoms';
import routes from '@/shared/constant/routes';

const SubscribeButton: React.FC<{ onRedirectEnd?: () => void }> = ({
  onRedirectEnd,
}) => {
  const { t } = useTranslation('payment');
  const { push } = useRouter();

  const handleClick = async () => {
    await push(routes.subscription);
    if (onRedirectEnd) onRedirectEnd();
  };

  return (
    <Button
      onClick={handleClick}
      size='full'
      className='h-56 !rounded-xl capitalize'
    >
      {t('subscribe')}
    </Button>
  );
};

export default SubscribeButton;
